import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const UsersCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${pxToRem('40px')};
  margin-top: ${pxToRem('40px')};
`;

export const UserInfoCard = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${pxToRem('16px')};
  border: solid ${pxToRem('2px')} #f0f0f0;
  background-color: white;
`;

export const UserInfoCardTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const UserInfoCardTitle = styled.div`
  padding: ${pxToRem('20px')} ${pxToRem('40px')};
  display: flex;
  flex-direction: row;
  height: 100%;
  align-items: center;
`;

export const UserInfoCardDeleteSection = styled.div`
  padding: ${pxToRem('20px')} ${pxToRem('40px')};
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  background: -webkit-linear-gradient(260deg, #49b696 86%, #48bab9 16%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  border: none;
  text-transform: uppercase;
  cursor: pointer;

  & > span {
    margin-right: ${pxToRem('8px')};
  }
`;

export const UserInfoCardContent = styled.div`
  background-color: rgba(7, 11, 21, 0.02);
  padding: ${pxToRem('24px')};
  -moz-border-radius-bottomleft: ${pxToRem('16px')};
  -moz-border-radius-bottomright: ${pxToRem('16px')};
  border-bottom-left-radius: ${pxToRem('16px')};
  border-bottom-right-radius: ${pxToRem('16px')};
  border-top: ${pxToRem('1px')} solid #e0e0e0;
`;

export const UserInfoIcon = styled.div`
  border-radius: 50%;
  width: ${pxToRem('48px')};
  height: ${pxToRem('48px')};
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${pxToRem('20px')};
  margin-right: ${pxToRem('24px')};

  & > img {
    width: ${pxToRem('23px')};
    height: ${pxToRem('23px')};
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  margin-left: ${pxToRem('40px')};

  & > div {
    margin-right: ${pxToRem('3px')};
  }

  ${props =>
    props.addedMargin &&
    css`
      margin-left: ${pxToRem('100px')};
    `}
`;

export const TableDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TableRows = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-column-gap: ${pxToRem('0px')};
  grid-row-gap: ${pxToRem('0px')};
  border-bottom: ${pxToRem('1px')} solid #e0e0e0;
  &:last-child {
    border-bottom: none;
  }
`;

export const InfoDescription = styled.div`
  color: ${props => props.theme.colors.grayText};
  text-align: start;
  margin-right: ${pxToRem('127px')};
  display: flex;
  align-content: flex-end;
  align-items: flex-start;
  :first-letter {
    text-transform: capitalize;
  }
`;

export const InfoDescriptionRow = styled.div`
  color: ${props => (props.lighter ? props.theme.colors.grayText : 'black')};
  text-align: start;
  //width: ${pxToRem('204px')};
  padding: ${pxToRem('16px')} ${pxToRem('40px')};
  display: flex;
  align-content: center;
  align-items: flex-start;
  :first-letter {
    text-transform: capitalize;
  }
`;

export const InfoData = styled.div`
  color: black;
  width: ${pxToRem('204px')};
  display: flex;
  align-items: center;
  height: 100%;
  ${props =>
    props.header &&
    css`
      width: unset;
      min-width: ${pxToRem('180px')};
    `}
  ${props =>
    props.status &&
    css`
      height: ${pxToRem('28px')};
      font-size: ${pxToRem('12px')};
      font-weight: bold;
      text-transform: uppercase;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.33;
      letter-spacing: ${pxToRem('2px')};
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: ${pxToRem('20px')};
      width: ${pxToRem('99px')};
      background: ${props.status === 'enabled'
        ? props.theme.colors.statusBgGreen
        : props.theme.colors.status.greyBg};
      color: ${props.status === 'enabled'
        ? props.theme.colors.statusText
        : props.theme.colors.darkGray};
    `};
`;

export const AddFriendContainer = styled.div`
  width: 100%;
  height: ${pxToRem('88px')};
  display: flex;
  justify-content: center;
  align-items: center;

  border: ${pxToRem('1px')} dashed #e0e0e0;
  background-color: rgba(255, 255, 255, 0.4);

  margin-top: ${pxToRem('40px')};
  margin-bottom: ${pxToRem('16px')};
  border-radius: ${pxToRem('16px')};

  & > span {
    background: -webkit-linear-gradient(260deg, #49b696 86%, #48bab9 16%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-transform: uppercase;
    cursor: pointer;
  }
  & > span:first-child {
    margin-right: ${pxToRem('10px')};
  }
`;
